import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueQrcodeReader from "vue-qrcode-reader";
import App from './App';
import router from './router';
import store from './store';
import {i18n} from './i18n';
import FlagIcon from 'vue-flag-icon';

Vue.use(BootstrapVue);
Vue.use(VueQrcodeReader);
Vue.use(FlagIcon);
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;

new Vue({
    render: h => h(App),
    router,
    store,
    i18n,
    components: {App}
}).$mount('#app');
